import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { validateAndSaveInsertion } from '../../../redux/thunks/insertionData/insertionData'
import { InitState } from '../../../redux/reducers/root/initialState'
import { useStore } from 'react-redux'

export function useUpdateLocalStateWhenSuggestionsLoaded() {
  const { suggestedTextFeature, insertionData } = useAppSelector((state: InitState) => ({
    suggestedTextFeature: state.suggestedTextFeature,
    insertionData: state.insertionFeature.insertionData,
  }))

  const store = useStore<InitState>()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const {
      suggestedTitle,
      suggestedDescription,
      suggestedLocation,
      isLocationManuallyEdited,
      isTitleManuallyEdited,
      isDescriptionManuallyEdited,
    } = suggestedTextFeature

    if (
      (suggestedTitle && suggestedTitle !== insertionData.adTitle) ||
      (suggestedDescription && suggestedDescription !== insertionData.adDescription) ||
      (suggestedLocation && suggestedLocation !== insertionData.adLocation)
    ) {
      const currentInsertionData = store.getState().insertionFeature.insertionData
      const newInsertionData = {
        ...currentInsertionData,
        adTitle: suggestedTitle && !isTitleManuallyEdited ? suggestedTitle : currentInsertionData.adTitle,
        adDescription:
          suggestedDescription && !isDescriptionManuallyEdited
            ? suggestedDescription
            : currentInsertionData.adDescription,
        adLocation:
          suggestedLocation && !isLocationManuallyEdited ? suggestedLocation : currentInsertionData.adLocation,
      }
      dispatch(validateAndSaveInsertion(newInsertionData))
    }
  }, [
    store,
    suggestedTextFeature,
    insertionData.adTitle,
    insertionData.adDescription,
    insertionData.adLocation,
    dispatch,
  ])
}
